import React__default, { createElement, Children, memo, useCallback, useEffect, forwardRef, useRef, useState, useMemo, Fragment } from 'react';
import styled, { withTheme, css, ThemeProvider } from 'styled-components';
import { debounce } from 'lodash-es';

var __makeTemplateObject = undefined && undefined.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = undefined && undefined.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

var RawButton = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: none;\n  color: inherit;\n  border: none;\n  padding: 0;\n  font: inherit;\n  cursor: pointer;\n  outline: inherit;\n"], ["\n  background: none;\n  color: inherit;\n  border: none;\n  padding: 0;\n  font: inherit;\n  cursor: pointer;\n  outline: inherit;\n"])));

var UnstyledButton = function UnstyledButton(_a) {
  var id = _a.id,
      _b = _a.onClick,
      onClick = _b === void 0 ? function () {} : _b,
      children = _a.children,
      className = _a.className,
      variant = _a.variant,
      disabled = _a.disabled,
      pressed = _a.pressed,
      expanded = _a.expanded,
      type = _a.type,
      tabIndex = _a.tabIndex,
      onMouseDown = _a.onMouseDown,
      onKeyDown = _a.onKeyDown,
      onFocus = _a.onFocus,
      onBlur = _a.onBlur;
  return createElement(RawButton, {
    id: id,
    onClick: onClick,
    className: className,
    variant: variant,
    disabled: disabled,
    "aria-pressed": pressed,
    "aria-expanded": expanded,
    type: type,
    tabIndex: tabIndex,
    onMouseDown: onMouseDown,
    onKeyDown: onKeyDown,
    onFocus: onFocus,
    onBlur: onBlur
  }, children);
};

var Button = withTheme(function (_a) {
  var theme = _a.theme,
      rest = __rest(_a, ["theme"]);

  return createElement(theme.button, __assign({}, rest));
});
var templateObject_1;

var __makeTemplateObject$1 = undefined && undefined.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign$1 = undefined && undefined.__assign || function () {
  __assign$1 = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign$1.apply(this, arguments);
};

var __rest$1 = undefined && undefined.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

var RawCard = styled.div(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject$1(["\n  /* stylelint-disable no-empty-block */\n"], ["\n  /* stylelint-disable no-empty-block */\n"])));

var UnstyledCard = function UnstyledCard(_a) {
  var className = _a.className,
      children = _a.children,
      variant = _a.variant;
  return createElement(RawCard, {
    className: className,
    variant: variant
  }, children);
};

var index = withTheme(function (_a) {
  var theme = _a.theme,
      rest = __rest$1(_a, ["theme"]);

  return createElement(theme.card, __assign$1({}, rest));
});
var templateObject_1$1;

var __makeTemplateObject$2 = undefined && undefined.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign$2 = undefined && undefined.__assign || function () {
  __assign$2 = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign$2.apply(this, arguments);
};

var __rest$2 = undefined && undefined.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};
/**
 * Wrapper for the Carousel
 */


var CarouselContainer = styled.div(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject$2(["\n  height: 150px;\n  max-width: 70vw;\n  width: 60vw;\n  overflow: hidden;\n  margin: auto;\n  position: relative;\n"], ["\n  height: 150px;\n  max-width: 70vw;\n  width: 60vw;\n  overflow: hidden;\n  margin: auto;\n  position: relative;\n"])));
/**
 * Scrolling track element for the Carousel
 */

var CarouselTrack = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject$2(["\n  display: flex;\n  position: absolute;\n  ", "\n  width: calc(", ");\n\n  &:hover {\n    animation-play-state: paused;\n  }\n\n  animation: scroll ", "\n    linear infinite;\n  transform: translate3d(0, 0, 0);\n\n  @keyframes scroll {\n    100% {\n      transform: translateX(", "50%);\n    }\n  }\n"], ["\n  display: flex;\n  position: absolute;\n  ", "\n  width: calc(", ");\n\n  &:hover {\n    animation-play-state: paused;\n  }\n\n  animation: scroll ", "\n    linear infinite;\n  transform: translate3d(0, 0, 0);\n\n  @keyframes scroll {\n    100% {\n      transform: translateX(", "50%);\n    }\n  }\n"])), function (props) {
  return props.direction === "right" ? "right: 0;" : "left: 0;";
}, function (props) {
  return props.itemWidth * props.count;
}, function (props) {
  return props.duration ? props.duration + "s" : "25s";
}, function (props) {
  return props.direction === "left" ? "-" : "";
});

var UnstyledCarousel = function UnstyledCarousel(_a) {
  var className = _a.className,
      _b = _a.direction,
      direction = _b === void 0 ? "left" : _b,
      itemWidth = _a.itemWidth,
      duration = _a.duration,
      children = _a.children;
  return createElement(CarouselContainer, {
    className: className
  }, createElement(CarouselTrack, {
    itemWidth: itemWidth,
    direction: direction,
    count: Children.count(children),
    duration: duration
  }, children));
};

var index$1 = withTheme(function (_a) {
  var theme = _a.theme,
      rest = __rest$2(_a, ["theme"]);

  return createElement(theme.carousel, __assign$2({}, rest));
});
var templateObject_1$2, templateObject_2;

var __makeTemplateObject$3 = undefined && undefined.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign$3 = undefined && undefined.__assign || function () {
  __assign$3 = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign$3.apply(this, arguments);
};

var __rest$3 = undefined && undefined.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};
/**
 * The base container that simply positions it absolutely below the input.
 */


var RawDropdownOptionsContainer = styled.div(templateObject_1$3 || (templateObject_1$3 = __makeTemplateObject$3(["\n  position: absolute;\n  height: auto;\n  width: 100%;\n  box-sizing: border-box;\n  overflow-x: auto;\n"], ["\n  position: absolute;\n  height: auto;\n  width: 100%;\n  box-sizing: border-box;\n  overflow-x: auto;\n"])));
/**
 * A `DropdownOptionsContainer` implementation with minimal styling.
 */

var UnstyledDropdownOptionsContainer = function UnstyledDropdownOptionsContainer(props) {
  return React__default.createElement(RawDropdownOptionsContainer, __assign$3({}, props));
};
/**
 * The container of all the dropdown options currently visible to a user.
 */


var DropdownOptionsContainer = memo(withTheme(function (_a) {
  var theme = _a.theme,
      children = _a.children,
      rest = __rest$3(_a, ["theme", "children"]);

  return React__default.createElement(theme.dropdownOptionsContainer, __assign$3({}, rest), React__default.createElement("div", {
    id: "North--Dropdown--Container-inner"
  }, children));
}));
var templateObject_1$3;

var __makeTemplateObject$4 = undefined && undefined.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign$4 = undefined && undefined.__assign || function () {
  __assign$4 = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign$4.apply(this, arguments);
};

var __rest$4 = undefined && undefined.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};
/**
 * The most basic `DropdownOption` possible
 */


var UnstyledDropdownOption = function UnstyledDropdownOption(_a) {
  var children = _a.children,
      className = _a.className;
  return React__default.createElement("div", {
    className: className + " North--UnstyledDropdownOption"
  }, children);
};
/**
 * The invisible button wrapping a `DropdownOption` to make it more accessible.
 */


var DropdownOptionButton = styled(UnstyledButton)(templateObject_1$4 || (templateObject_1$4 = __makeTemplateObject$4(["\n  all: inherit;\n  cursor: pointer;\n  display: block;\n  width: 100%;\n"], ["\n  all: inherit;\n  cursor: pointer;\n  display: block;\n  width: 100%;\n"])));
/**
 * An option of a dropdown that a user can select.
 */

var DropdownOption = memo(withTheme(function (_a) {
  var parentPassedHasFocus = _a.hasFocus,
      theme = _a.theme,
      onSelect = _a.onSelect,
      id = _a.id,
      rest = __rest$4(_a, ["hasFocus", "theme", "onSelect", "id"]);

  var _b = React__default.useState(false),
      hasFocus = _b[0],
      setHasFocus = _b[1];

  var onFocus = React__default.useCallback(function () {
    return setHasFocus(true);
  }, [setHasFocus]);
  var onBlur = React__default.useCallback(function () {
    return setHasFocus(false);
  }, [setHasFocus]);
  return React__default.createElement(DropdownOptionButton, {
    id: id,
    onFocus: onFocus,
    onBlur: onBlur,
    onClick: onSelect,
    onMouseDown: onSelect,
    tabIndex: -1,
    className: "North--DropdownOptionButton"
  }, React__default.createElement(theme.dropdownOption, __assign$4({}, rest, {
    hasFocus: hasFocus || parentPassedHasFocus
  })));
}));
var templateObject_1$4;

var __makeTemplateObject$5 = undefined && undefined.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign$5 = undefined && undefined.__assign || function () {
  __assign$5 = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign$5.apply(this, arguments);
};

var __rest$5 = undefined && undefined.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};
/**
 * The base container.
 */


var RawDropdownContainer = styled.div(templateObject_1$5 || (templateObject_1$5 = __makeTemplateObject$5(["\n  cursor: text;\n"], ["\n  cursor: text;\n"])));
/**
 * A `DropdownContainer` implementation with minimal styling.
 */

var UnstyledDropdownContainer = function UnstyledDropdownContainer(props) {
  return React__default.createElement(RawDropdownContainer, __assign$5({}, props));
};
/**
 * The component that contains the contents of the dropdown (the text input and selected
 * values if multi).
 */


var DropdownContainer = memo(withTheme(function (_a) {
  var theme = _a.theme,
      rest = __rest$5(_a, ["theme"]);

  return React__default.createElement(theme.dropdownContainer, __assign$5({}, rest));
}));
var templateObject_1$5;

var useKeyEvents = function useKeyEvents(onKeyDown, onKeyPress, onKeyUp) {
  var internalOnKeyDown = useCallback(function (event) {
    if (onKeyDown) {
      onKeyDown(event.key);
    }
  }, [onKeyDown]);
  var internalOnKeyPress = useCallback(function (event) {
    if (onKeyPress) {
      onKeyPress(event.key);
    }
  }, [onKeyPress]);
  var internalOnKeyUp = useCallback(function (event) {
    if (onKeyUp) {
      onKeyUp(event.key);
    }
  }, [onKeyUp]);
  return {
    onKeyDown: internalOnKeyDown,
    onKeyPress: internalOnKeyPress,
    onKeyUp: internalOnKeyUp
  };
};

var useOnClickOutside = function useOnClickOutside(ref, handler) {
  useEffect(function () {
    var listener = function listener(event) {
      // Do nothing if clicking ref's element or descendent elements
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }

      handler(event);
    };

    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener);
    return function () {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
    };
  }, [ref, handler]);
};

var __makeTemplateObject$6 = undefined && undefined.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign$6 = undefined && undefined.__assign || function () {
  __assign$6 = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign$6.apply(this, arguments);
};

var __rest$6 = undefined && undefined.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

var RawTextInput = styled.input(templateObject_1$6 || (templateObject_1$6 = __makeTemplateObject$6(["\n  /* stylelint-disable no-empty-block */\n"], ["\n  /* stylelint-disable no-empty-block */\n"])));
/**
 * A single-line `TextInput` component, unstyled.
 */

var UnstyledTextInput = forwardRef(function (_a, ref) {
  var className = _a.className,
      defaultValue = _a.defaultValue,
      onChange = _a.onChange,
      placeholder = _a.placeholder,
      required = _a.required,
      type = _a.type,
      value = _a.value,
      label = _a.label,
      _b = _a.readOnly,
      readOnly = _b === void 0 ? false : _b,
      _c = _a.disabled,
      disabled = _c === void 0 ? false : _c,
      maxLength = _a.maxLength,
      tabIndex = _a.tabIndex,
      onFocus = _a.onFocus,
      onBlur = _a.onBlur,
      onKeyDown = _a.onKeyDown,
      onKeyPress = _a.onKeyPress,
      onKeyUp = _a.onKeyUp,
      size = _a.size;
  /**
   * Memoized onChange callback for the html text input element. Returns the text value rather
   * than the change event.
   */

  var internalOnChange = useCallback(function (event) {
    onChange(event.target.value);
  }, [onChange]);
  var keyEvents = useKeyEvents(onKeyDown, onKeyPress, onKeyUp);
  return createElement(RawTextInput, __assign$6({
    className: className,
    defaultValue: defaultValue,
    onChange: internalOnChange,
    placeholder: placeholder,
    required: required,
    type: type,
    value: value,
    readOnly: readOnly,
    disabled: disabled,
    maxLength: maxLength,
    tabIndex: tabIndex,
    "aria-label": label,
    onFocus: onFocus,
    onBlur: onBlur
  }, keyEvents, {
    size: size,
    ref: ref
  }));
});
UnstyledTextInput.displayName = "UnstyledTextInput";
var ForwardedTextInput = forwardRef(function (_a, ref) {
  var theme = _a.theme,
      rest = __rest$6(_a, ["theme"]);

  return createElement(theme.textInput, __assign$6({}, rest, {
    ref: ref
  }));
});
ForwardedTextInput.displayName = "ForwardedTextInput";
/**
 * A single-line `TextInput` component, withTheme.
 */

var TextInput = withTheme(ForwardedTextInput);
TextInput.displayName = "TextInput";
var templateObject_1$6;
/**
 * Does a case-insensitive check to see if option contains value
 */

var filterFunction = function filterFunction(option, value) {
  return option.value.toLowerCase().indexOf(value.toLowerCase()) !== -1;
};

var buildDropdownOptionId = function buildDropdownOptionId(value) {
  return "North--DropdownOption--" + value;
};

var __makeTemplateObject$7 = undefined && undefined.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};
/**
 * The element that serves as an anchor for the options. Located directly below the dropdown
 * input.
 */


var DropdownOptionsAnchor = styled.div(templateObject_1$7 || (templateObject_1$7 = __makeTemplateObject$7(["\n  position: relative;\n  width: 100%;\n"], ["\n  position: relative;\n  width: 100%;\n"])));
var templateObject_1$7;
/**
 * Returns a ref and functions for setting focus on that ref.
 */

var useFocus = function useFocus() {
  /**
   * HTML element ref.
   */
  var ref = useRef(null);
  /**
   * Function to request focus on the ref.
   */

  var focus = useCallback(function () {
    if (ref.current) {
      ref.current.focus();
    }
  }, [ref]);
  /**
   * Function to remove focus from the ref.
   */

  var blur = useCallback(function () {
    if (ref.current) {
      ref.current.blur();
    }
  }, []);
  return [ref, focus, blur];
};

var __makeTemplateObject$8 = undefined && undefined.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};
/**
 * Magic constant that indicates there is no focused value.
 */


var NO_OPTION_FOCUSED_INDEX = -1;
var NO_OPTION_FOCUSED = {
  index: NO_OPTION_FOCUSED_INDEX,
  value: ""
};
/**
 * The top element in the dropdown DOM subtree.
 */

var Container = styled.div(templateObject_1$8 || (templateObject_1$8 = __makeTemplateObject$8(["\n  display: inline-block;\n"], ["\n  display: inline-block;\n"])));
/**
 * A dropdown component can serve multiple purposes. It can be used as an autocomplete, as
 * an alternative to a radio button group and much more.
 */

var Dropdown = function Dropdown(_a) {
  var value = _a.value,
      _b = _a.options,
      options = _b === void 0 ? [] : _b,
      _c = _a.filterFunction,
      filterFunction$1 = _c === void 0 ? filterFunction : _c,
      onChange = _a.onChange,
      _d = _a.filterable,
      filterable = _d === void 0 ? false : _d,
      _e = _a.creatable,
      creatable = _e === void 0 ? false : _e,
      tabIndex = _a.tabIndex,
      placeholder = _a.placeholder,
      onKeyDown = _a.onKeyDown,
      onKeyPress = _a.onKeyPress,
      onKeyUp = _a.onKeyUp,
      readOnly = _a.readOnly;
  /**
   * The current value in the textbox. It is not necessarily the same as `value`.
   */

  var _f = useState(value || ""),
      internalValue = _f[0],
      setInternalValue = _f[1];
  /**
   * Ref to top-level element related to this dropdown in the DOM tree.
   */


  var containerElement = useRef(null);
  /**
   * Hook for managing focus on the input.
   */

  var _g = useFocus(),
      inputRef = _g[0],
      blurInput = _g[2];
  /**
   * Flag on whether to render the dropdown options or not.
   */


  var _h = useState(false),
      renderDropdownOptions = _h[0],
      setRenderDropdownOptions = _h[1];
  /**
   * The current focused value. `-1` means no option is
   * currently focused.
   */


  var _j = useState(NO_OPTION_FOCUSED),
      curFocusedOption = _j[0],
      setCurFocusedOption = _j[1];
  /**
   * Flag on whether to scroll to the currently focusedValue
   */


  var _k = useState(false),
      shouldScrollToFocusedOption = _k[0],
      setShouldScrollToFocusedOption = _k[1];
  /**
   * The memoized options that should be displayed to the user based on their input
   */


  var filteredOptions = useMemo(function () {
    var newFilteredOptions = !filterable ? options : options.filter(function (option) {
      return filterFunction$1(option, internalValue);
    });
    return newFilteredOptions;
  }, [filterable, options, filterFunction$1, internalValue]);
  /**
   * Callbacks to show/hide the dropdown when the input element gains/loses focus
   */

  var onInputFocus = useCallback(function () {
    return setRenderDropdownOptions(true);
  }, [setRenderDropdownOptions]);
  var onInputBlur = useCallback(function () {
    return setRenderDropdownOptions(false);
  }, [setRenderDropdownOptions]);
  /*
   * Hide the dropdown options if a click/touch outside is detected
   */

  var onClickOutside = useCallback(function () {
    setRenderDropdownOptions(false); // Reset input if dirty

    if (value !== internalValue) {
      setInternalValue(value);
    }
  }, [internalValue, value]);
  useOnClickOutside(containerElement, onClickOutside);
  /**
   * Callback for when an arrow key is pressed in the input by the user
   * @param direction - The direction of the arrow key that was pressed
   */

  var onArrowKeyPress = useCallback(function (direction) {
    var newFocusIndex; // make a copy

    if (direction === "down") {
      if (curFocusedOption.index === NO_OPTION_FOCUSED_INDEX) {
        newFocusIndex = filteredOptions.length > 0 ? 0 : NO_OPTION_FOCUSED_INDEX;
      } else {
        newFocusIndex = Math.min(filteredOptions.length - 1, curFocusedOption.index + 1); // upper bound of last item in options
      }
    } else {
      if (curFocusedOption.index !== NO_OPTION_FOCUSED_INDEX) {
        newFocusIndex = Math.max(0, curFocusedOption.index - 1);
      }
    }

    if (newFocusIndex !== undefined && newFocusIndex !== curFocusedOption.index) {
      var newFocusOption = {
        index: newFocusIndex,
        value: filteredOptions[newFocusIndex].value
      };
      setCurFocusedOption(newFocusOption);
      setShouldScrollToFocusedOption(true);
    } // TODO: add `e.preventDefault` to prevent arrow keys from scrolling the container

  }, [curFocusedOption.index, filteredOptions]);
  /**
   * Callback for when a dropdown option is selected by the user
   * @param option - The option selected by the user
   */

  var onDropdownOptionClick = useCallback(function (option) {
    setInternalValue(option.value);
    onChange(option.value);
    setRenderDropdownOptions(false);
  }, [onChange]);
  /**
   * Callback for when the user input changes. It updates the internal value and
   * potentially updates the external value.
   */

  var onInputChange = useCallback(function (input) {
    setInternalValue(input);

    if (creatable || options.find(function (option) {
      return option.value === input;
    })) {
      onChange(input);
    }
  }, [creatable, options, onChange]);
  /**
   * Callback for when a key in the input is pressed.
   *
   */

  var onInputKeyUp = useCallback(function (key) {
    /**
     * If the enter key is pressed and there are options available,
     * it autopopulates the input with the internally focused option.
     * If no option is focused, it picks the first option from the
     * filtered options.
     */
    if (key === "Enter") {
      if (filteredOptions.length > 0) {
        if (curFocusedOption.index !== NO_OPTION_FOCUSED_INDEX) {
          onInputChange(curFocusedOption.value);
        } else {
          onInputChange(filteredOptions[0].value);
        } // reset current focused option


        setCurFocusedOption(NO_OPTION_FOCUSED); // an option was clicked, close dropdown menu

        blurInput();
      }
    } else if (key === "ArrowUp") {
      onArrowKeyPress("up");
    } else if (key === "ArrowDown") {
      onArrowKeyPress("down");
    }

    if (onKeyUp) {
      onKeyUp(key);
    }
  }, [filteredOptions, onArrowKeyPress, onInputChange, onKeyUp]);
  /**
   * Creates the dropdown options to render (if any)
   */

  var optionsElements = useMemo(function () {
    if (renderDropdownOptions && filteredOptions.length > 0 && !readOnly) {
      return React__default.createElement(DropdownOptionsContainer, null, filteredOptions.map(function (option) {
        var optionHasFocus = curFocusedOption.index !== NO_OPTION_FOCUSED_INDEX && filteredOptions[curFocusedOption.index] ? option.value === filteredOptions[curFocusedOption.index].value : false;
        return React__default.createElement(DropdownOption, {
          key: option.value,
          id: buildDropdownOptionId(option.value),
          hasFocus: optionHasFocus,
          onSelect: function onSelect() {
            return onDropdownOptionClick(option);
          }
        }, option.value);
      }));
    }

    return null;
  }, [curFocusedOption.index, filteredOptions, onDropdownOptionClick, readOnly, renderDropdownOptions]);
  /**
   * Checks if filtered options has changed. If so, update the current focused value to
   * the most accurate index or remove focus if it's not visible anymore.
   */

  useEffect(function () {
    // find the old focused value's index in the new filtered options
    var newFocusedIndex = filteredOptions.findIndex(function (option) {
      return option.value === curFocusedOption.value;
    });

    if (newFocusedIndex === NO_OPTION_FOCUSED_INDEX) {
      setCurFocusedOption(NO_OPTION_FOCUSED);
    } else {
      var newFocusedOption = {
        index: newFocusedIndex,
        value: filteredOptions[newFocusedIndex].value
      };
      setCurFocusedOption(newFocusedOption);
    }
  }, [curFocusedOption.value, filteredOptions]);
  /**
   * Checks if the current focused option must be scrolled to and scrolls to it if needed.
   * **NOTE: CURRENTLY BROKEN, SINCE WE DO NOT SET THE HEIGHT OF THE ELEMENT (ONLY `max-height`)**
   */

  useEffect(function () {
    if (shouldScrollToFocusedOption) {
      var anchorEl = document.getElementById("North--Dropdown--Container-inner");
      var focusedOptionEl = document.getElementById(buildDropdownOptionId(curFocusedOption.value));

      if (anchorEl && focusedOptionEl) {
        var anchorRect = anchorEl.getBoundingClientRect();
        var focusedOptionRect = focusedOptionEl.getBoundingClientRect();
        var overScroll = focusedOptionEl.offsetHeight / 3;

        if (focusedOptionRect.bottom + overScroll > anchorRect.bottom) {
          anchorEl.scrollTop = Math.min(focusedOptionEl.offsetTop + focusedOptionEl.clientHeight - anchorEl.offsetHeight + overScroll, anchorEl.scrollHeight);
        } else if (focusedOptionRect.top - overScroll < anchorRect.top) {
          anchorEl.scrollTop = Math.max(focusedOptionEl.offsetTop - overScroll, 0);
        }
      }
    }
  }, [shouldScrollToFocusedOption, curFocusedOption.value]);
  return React__default.createElement(Container, {
    ref: containerElement
  }, React__default.createElement(DropdownContainer, null, React__default.createElement(TextInput, {
    variant: "dropdown",
    onChange: onInputChange,
    value: internalValue,
    onFocus: onInputFocus,
    onBlur: onInputBlur,
    placeholder: placeholder,
    readOnly: !filterable && !creatable || readOnly,
    tabIndex: tabIndex,
    onKeyDown: onKeyDown,
    onKeyPress: onKeyPress,
    onKeyUp: onInputKeyUp,
    ref: inputRef
  }), React__default.createElement(DropdownOptionsAnchor, null, optionsElements)));
};

var Dropdown$1 = memo(Dropdown);
var templateObject_1$8;

var __makeTemplateObject$9 = undefined && undefined.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign$7 = undefined && undefined.__assign || function () {
  __assign$7 = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign$7.apply(this, arguments);
};

var __rest$7 = undefined && undefined.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

var RawText = styled.p(templateObject_1$9 || (templateObject_1$9 = __makeTemplateObject$9(["\n  /* stylelint-disable no-empty-block */\n"], ["\n  /* stylelint-disable no-empty-block */\n"])));
/**
 * The unstyled version of a `Text` component. This should only be used when defining a theme.
 */

var UnstyledText = function UnstyledText(_a) {
  var _b = _a.as,
      as = _b === void 0 ? "p" : _b,
      id = _a.id,
      className = _a.className,
      children = _a.children;
  return createElement(RawText, {
    id: id,
    className: className,
    as: as
  }, children);
};
/**
 * A component for displaying text.
 */


var Text = withTheme(function (_a) {
  var theme = _a.theme,
      rest = __rest$7(_a, ["theme"]);

  return createElement(theme.text, __assign$7({}, rest));
});
var templateObject_1$9;

var __assign$8 = undefined && undefined.__assign || function () {
  __assign$8 = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign$8.apply(this, arguments);
};

var __rest$8 = undefined && undefined.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};
/**
 * Default implementation. Places the value on the left and the remove button on the right.
 */


var UnstyledDropdownMultiValue = function UnstyledDropdownMultiValue(_a) {
  var value = _a.value,
      children = _a.children,
      className = _a.className;
  return React__default.createElement(Text, {
    as: "span",
    className: className
  }, value, children);
};
/**
 * A selected value of a `MultiDropdown`. It must accept children as that is how the
 * `DropdownMultiValueRemove` component gets rendered.
 */


var DropdownMultiValue = memo(withTheme(function (_a) {
  var theme = _a.theme,
      rest = __rest$8(_a, ["theme"]);

  return React__default.createElement(theme.dropdownMultiValue, __assign$8({}, rest));
}));

var __assign$9 = undefined && undefined.__assign || function () {
  __assign$9 = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign$9.apply(this, arguments);
};

var __rest$9 = undefined && undefined.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};
/**
 * A button with an `X` inside it.
 */


var UnstyledDropdownMultiValueRemove = function UnstyledDropdownMultiValueRemove(_a) {
  var onRemove = _a.onRemove,
      className = _a.className;
  return React__default.createElement(Button, {
    onClick: onRemove,
    removeSharedStyles: true,
    className: className
  }, "X");
};
/**
 * The button to remove a selected value.
 */


var DropdownMultiValueRemove = memo(withTheme(function (_a) {
  var theme = _a.theme,
      rest = __rest$9(_a, ["theme"]);

  return React__default.createElement(theme.dropdownMultiValueRemove, __assign$9({}, rest));
}));

var __makeTemplateObject$a = undefined && undefined.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};
/**
 * The top element in the dropdown DOM subtree.
 */


var Container$1 = styled.div(templateObject_1$a || (templateObject_1$a = __makeTemplateObject$a(["\n  display: inline-block;\n"], ["\n  display: inline-block;\n"])));
/**
 * The container of the selected values and text input. Basically a wrapping, left-aligned flexbox.
 */

var ValuesContainer = styled.div(templateObject_2$1 || (templateObject_2$1 = __makeTemplateObject$a(["\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-items: center;\n"], ["\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-items: center;\n"])));
/**
 * A dropdown component that allows the user to select multiple values.
 */

var MultiDropdown = memo(withTheme(function (_a) {
  var values = _a.values,
      _b = _a.options,
      options = _b === void 0 ? [] : _b,
      _c = _a.filterFunction,
      filterFunction$1 = _c === void 0 ? filterFunction : _c,
      onChange = _a.onChange,
      _d = _a.filterable,
      filterable = _d === void 0 ? false : _d,
      _e = _a.creatable,
      creatable = _e === void 0 ? false : _e,
      _f = _a.creatableTriggerKeys,
      creatableTriggerKeys = _f === void 0 ? ["Enter"] : _f,
      tabIndex = _a.tabIndex,
      placeholder = _a.placeholder,
      onKeyDown = _a.onKeyDown,
      onKeyPress = _a.onKeyPress,
      onKeyUp = _a.onKeyUp,
      readOnly = _a.readOnly;
  /**
   * Magic constant that indicates there is no focused value.
   */

  var NO_OPTION_FOCUSED_INDEX = -1;
  var NO_OPTION_FOCUSED = {
    index: NO_OPTION_FOCUSED_INDEX,
    value: ""
  };
  /**
   * The internal value that is being typed into input. It is never propagated to the user.
   */

  var _g = useState(""),
      internalValue = _g[0],
      setInternalValue = _g[1];
  /**
   * Hook for managing focus on the input.
   */


  var _h = useFocus(),
      inputRef = _h[0],
      focusInput = _h[1];
  /**
   * Ref to top-level element related to this dropdown in the DOM tree.
   */


  var containerElement = useRef(null);
  /**
   * Flag on whether to render the dropdown options or not.
   */

  var _j = useState(false),
      renderDropdownOptions = _j[0],
      setRenderDropdownOptions = _j[1];
  /**
   * The current focused value. `-1` means no option is
   * currently focused.
   */


  var _k = useState(NO_OPTION_FOCUSED),
      curFocusedOption = _k[0],
      setCurFocusedOption = _k[1];
  /**
   * Flag on whether to scroll to the currently focusedValue
   */


  var _l = useState(false),
      shouldScrollToFocusedOption = _l[0],
      setShouldScrollToFocusedOption = _l[1];
  /**
   * The memoized options that should be displayed to the user based on their input.
   */


  var filteredOptions = useMemo(function () {
    if (!filterable) {
      return options;
    }

    return options.filter(function (option) {
      return filterFunction$1(option, internalValue);
    });
  }, [filterable, options, filterFunction$1, internalValue]);
  /**
   * Callback to show/hide the dropdown when the input element gains/loses focus.
   */

  var onInputFocus = useCallback(function () {
    setRenderDropdownOptions(true);
    focusInput();
  }, [setRenderDropdownOptions, focusInput]);
  var onInputBlur = useCallback(function () {
    setRenderDropdownOptions(false);
  }, [setRenderDropdownOptions]);
  /*
   * Hide the dropdown options if a click/touch outside is detected
   */

  var onClickOutside = useCallback(function () {
    setRenderDropdownOptions(false); // Updates values if the current value in the text input is valid

    if (internalValue.trim().length > 0 && (creatable || options.find(function (_a) {
      var value = _a.value;
      return value === internalValue;
    }))) {
      onChange(values.concat([internalValue]));
      setInternalValue("");
    }
  }, [creatable, internalValue, onChange, options, values]);
  useOnClickOutside(containerElement, onClickOutside);
  /**
   * Callback for when a dropdown option is selected by the user
   * @param option - The option selected by the user
   */

  var onDropdownOptionClick = useCallback(function (option) {
    setInternalValue("");
    onChange(values.concat([option.value]));
    focusInput();
  }, [focusInput, onChange, values]);
  /**
   * Callback for when the user input changes. It updates the internal value.
   */

  var onInputChange = useCallback(function (input) {
    setInternalValue(input);
  }, []);
  /**
   * Callback for when a key in the input is pressed.
   * If a creatable trigger key is pressed, it adds the current input to the selected values if it is
   * creatable. Otherwise, it adds the first option from the options array (if there is one).
   */

  var onInputKeyDown = useCallback(function (key) {
    if (creatableTriggerKeys.includes(key) && internalValue.trim().length > 0) {
      if (creatable) {
        onChange(values.concat([internalValue]));
        setInternalValue("");
      } else if (filteredOptions.length > 0) {
        onChange(values.concat([filteredOptions[0].value]));
        setInternalValue("");
      }
    }

    if (key === "Backspace" && internalValue.length === 0 && values.length > 0) {
      var newValues = values.slice();
      newValues.length -= 1;
      onChange(newValues);
    }

    if (onKeyDown) {
      onKeyDown(key);
    }
  }, [internalValue, values, onKeyDown, creatable, filteredOptions, onChange]);
  /**
   * Callback to remove the value at a given index
   */

  var removeValue = useCallback(function (index) {
    var notIndex = function notIndex(v, i) {
      return i !== index;
    };

    onChange(values.filter(notIndex));
  }, [onChange, values]);
  /**
   * Callback for when an arrow key is pressed in the input by the user
   * @param direction - The direction of the arrow key that was pressed
   */

  var onArrowKeyPress = useCallback(function (direction) {
    var newFocusIndex; // make a copy

    if (direction === "down") {
      if (curFocusedOption.index === NO_OPTION_FOCUSED_INDEX) {
        newFocusIndex = filteredOptions.length > 0 ? 0 : NO_OPTION_FOCUSED_INDEX;
      } else {
        newFocusIndex = Math.min(filteredOptions.length - 1, curFocusedOption.index + 1); // upper bound of last item in options
      }
    } else {
      if (curFocusedOption.index !== NO_OPTION_FOCUSED_INDEX) {
        newFocusIndex = Math.max(0, curFocusedOption.index - 1);
      }
    }

    if (newFocusIndex !== undefined && newFocusIndex !== curFocusedOption.index) {
      var newFocusOption = {
        index: newFocusIndex,
        value: filteredOptions[newFocusIndex].value
      };
      setCurFocusedOption(newFocusOption);
      setShouldScrollToFocusedOption(true);
    } // TODO: add `e.preventDefault` to prevent arrow keys from scrolling the container

  }, [NO_OPTION_FOCUSED_INDEX, curFocusedOption.index, filteredOptions]);
  /**
   * Callback for when a key in the input is pressed.
   *
   */

  var onInputKeyUp = useCallback(function (key) {
    /**
     * If the enter key is pressed and there are options available,
     * it autopopulates the input with the internally focused option.
     * If no option is focused, it picks the first option from the
     * filtered options.
     */
    if (key === "Enter") {
      if (filteredOptions.length > 0) {
        if (curFocusedOption.index !== NO_OPTION_FOCUSED_INDEX) {
          onDropdownOptionClick(curFocusedOption);
        } else {
          onDropdownOptionClick(filteredOptions[0]);
        } // reset current focused option


        setCurFocusedOption(NO_OPTION_FOCUSED); // // an option was clicked, close dropdown menu

        onInputBlur();
      }
    } else if (key === "ArrowUp") {
      onArrowKeyPress("up");
    } else if (key === "ArrowDown") {
      onArrowKeyPress("down");
    }

    if (onKeyUp) {
      onKeyUp(key);
    }
  }, [NO_OPTION_FOCUSED, NO_OPTION_FOCUSED_INDEX, curFocusedOption, filteredOptions, onArrowKeyPress, onDropdownOptionClick, onInputBlur, onKeyUp]);
  /**
   * Creates the dropdown options to render (if any)
   */

  var optionsElements = null;

  if (renderDropdownOptions && filteredOptions.length > 0 && !readOnly) {
    optionsElements = React__default.createElement(DropdownOptionsContainer, null, filteredOptions.map(function (option) {
      var optionHasFocus = curFocusedOption.index !== NO_OPTION_FOCUSED_INDEX && filteredOptions[curFocusedOption.index] ? option.value === filteredOptions[curFocusedOption.index].value : false;
      return React__default.createElement(DropdownOption, {
        hasFocus: optionHasFocus,
        key: option.value,
        onSelect: function onSelect() {
          return onDropdownOptionClick(option);
        }
      }, option.value);
    }));
  }
  /**
   * Creates the already-selected value elements
   */


  var multiValueElements = values.map(function (v, i) {
    return React__default.createElement(DropdownMultiValue, {
      value: v,
      key: v + "-" + i
    }, !readOnly && React__default.createElement(DropdownMultiValueRemove, {
      onRemove: function onRemove() {
        return removeValue(i);
      }
    }));
  });
  return React__default.createElement(Container$1, {
    ref: containerElement,
    onClick: onInputFocus
  }, React__default.createElement(DropdownContainer, null, React__default.createElement(ValuesContainer, null, multiValueElements, React__default.createElement(TextInput, {
    variant: "dropdown",
    onChange: onInputChange,
    value: internalValue,
    onFocus: onInputFocus,
    onBlur: onInputBlur,
    placeholder: placeholder,
    readOnly: !filterable && !creatable || readOnly,
    tabIndex: tabIndex,
    onKeyDown: onInputKeyDown,
    onKeyPress: onKeyPress,
    onKeyUp: onInputKeyUp,
    size: internalValue.length + 1,
    ref: inputRef
  }))), React__default.createElement(DropdownOptionsAnchor, null, optionsElements));
}));
var templateObject_1$a, templateObject_2$1;

var __makeTemplateObject$b = undefined && undefined.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign$a = undefined && undefined.__assign || function () {
  __assign$a = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign$a.apply(this, arguments);
};

var __rest$a = undefined && undefined.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

var IndicatorContainer = styled.div(templateObject_1$b || (templateObject_1$b = __makeTemplateObject$b(["\n  display: flex;\n  justify-content: center;\n"], ["\n  display: flex;\n  justify-content: center;\n"])));
var IndicatorDot = styled.li(templateObject_2$2 || (templateObject_2$2 = __makeTemplateObject$b(["\n  list-style: none;\n  width: 10px;\n  height: 10px;\n  margin: 0 5px;\n  border-radius: 100%;\n  background: rgba(196, 196, 196, 0.5);\n\n  &.active {\n    background: #000000;\n  }\n\n  &:hover {\n    cursor: pointer;\n  }\n"], ["\n  list-style: none;\n  width: 10px;\n  height: 10px;\n  margin: 0 5px;\n  border-radius: 100%;\n  background: rgba(196, 196, 196, 0.5);\n\n  &.active {\n    background: #000000;\n  }\n\n  &:hover {\n    cursor: pointer;\n  }\n"])));
var Indicator = withTheme(function (_a) {
  var theme = _a.theme,
      rest = __rest$a(_a, ["theme"]);

  return createElement(theme.indicator, __assign$a({}, rest));
});

var UnstyledIndicator = function UnstyledIndicator(_a) {
  var className = _a.className,
      isActive = _a.isActive,
      onClick = _a.onClick;
  return createElement(IndicatorDot, {
    className: isActive ? className + " active" : className,
    onClick: onClick
  });
};

var getIndicators = function getIndicators(themed, count, currentIndex, _onClick) {
  var dots = [];

  var _loop_1 = function _loop_1(i) {
    dots.push(themed ? createElement(Indicator, {
      key: "indicator-" + i,
      onClick: function onClick() {
        return _onClick(i);
      },
      isActive: currentIndex === i
    }) : createElement(UnstyledIndicator, {
      key: "indicator-" + i,
      onClick: function onClick() {
        return _onClick(i);
      },
      isActive: currentIndex === i
    }));
  };

  for (var i = 0; i < count; i++) {
    _loop_1(i);
  }

  return createElement(IndicatorContainer, {
    className: "indicator__container"
  }, dots);
};

var templateObject_1$b, templateObject_2$2;

var __makeTemplateObject$c = undefined && undefined.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign$b = undefined && undefined.__assign || function () {
  __assign$b = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign$b.apply(this, arguments);
};

var __rest$b = undefined && undefined.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

var GalleryContainer = styled.div(templateObject_1$c || (templateObject_1$c = __makeTemplateObject$c(["\n  overflow: hidden;\n  width: 500px;\n"], ["\n  overflow: hidden;\n  width: 500px;\n"])));
/**
 * Container for the gallery items and where animations will be applied. Can be styled via class of `gallery__slider`
 */

var GallerySlider = styled.div(templateObject_2$3 || (templateObject_2$3 = __makeTemplateObject$c(["\n  display: flex;\n  margin-bottom: 20px;\n"], ["\n  display: flex;\n  margin-bottom: 20px;\n"])));

var UnstyledGallery = function UnstyledGallery(_a) {
  var className = _a.className,
      children = _a.children,
      _b = _a.duration,
      duration = _b === void 0 ? 200 : _b,
      _c = _a.threshold,
      threshold = _c === void 0 ? 20 : _c,
      _d = _a.easing,
      easing = _d === void 0 ? "ease-out" : _d,
      _e = _a.perPage,
      perPage = _e === void 0 ? 1 : _e,
      _f = _a.startIndex,
      startIndex = _f === void 0 ? 0 : _f,
      _g = _a.draggable,
      draggable = _g === void 0 ? false : _g,
      _h = _a.loop,
      loop = _h === void 0 ? false : _h,
      _j = _a.resizeDebounce,
      resizeDebounce = _j === void 0 ? 250 : _j,
      _k = _a.showIndicators,
      showIndicators = _k === void 0 ? true : _k,
      _l = _a.autoScroll,
      autoScroll = _l === void 0 ? false : _l,
      _m = _a.autoScrollInterval,
      autoScrollInterval = _m === void 0 ? 4000 : _m,
      _o = _a.useThemedIndicators,
      useThemedIndicators = _o === void 0 ? false : _o,
      _p = _a.onInit,
      onInit = _p === void 0 ? function () {} : _p,
      _q = _a.onChange,
      onChange = _q === void 0 ? function () {} : _q;
  var galleryRef = useRef(null);
  var sliderRef = useRef(null);

  var _r = useState(startIndex),
      currentItem = _r[0],
      setCurrentItem = _r[1];

  var _s = useState(0),
      galleryWidth = _s[0],
      setWidth = _s[1];

  var _t = useState(false),
      dragged = _t[0],
      setDragged = _t[1]; // flag for dirty (dragged/scrolled) gallery


  var indices = useRef({
    from: null,
    to: null
  });
  var isDown = false;
  var drag = draggable ? {
    startX: 0,
    endX: 0,
    startY: 0,
    letGo: null
  } : null;
  var innerElements = useRef(null); // slides to the currently focused item

  var slideToCurrent = useCallback(function () {
    sliderRef.current.style["transform"] = "translate3d(-" + Math.round(currentItem * (galleryWidth / perPage)) + "px, 0, 0)";
  }, [currentItem, galleryWidth, perPage, sliderRef]); // resets drag properties

  var clearDrag = function clearDrag() {
    drag = {
      startX: 0,
      endX: 0,
      startY: 0,
      letGo: null
    };
  };

  var updateIndices = useCallback(function (nextIndex) {
    indices.current = {
      from: currentItem,
      to: nextIndex
    };
    setCurrentItem(nextIndex);
  }, [currentItem]); // go to the previous item in the gallery

  var prev = function prev(n, onPrevCompleted) {
    if (n === void 0) {
      n = 1;
    }

    if (onPrevCompleted === void 0) {
      onPrevCompleted = function onPrevCompleted() {
        return [];
      };
    }

    if (currentItem === 0 && loop) {
      updateIndices(innerElements.current.length - perPage);
    } else {
      updateIndices(Math.max(currentItem - Number(n), 0));
    }

    slideToCurrent(); // call callbacks

    onChange(indices.current);
    onPrevCompleted();
  }; // go to the next item in the gallery


  var next = useCallback(function (n, onNextCompleted) {
    if (n === void 0) {
      n = 1;
    }

    if (onNextCompleted === void 0) {
      onNextCompleted = function onNextCompleted() {
        return [];
      };
    }

    if (currentItem === innerElements.current.length - perPage && loop) {
      updateIndices(0);
    } else {
      updateIndices(Math.min(currentItem + Number(n), innerElements.current.length - perPage));
    }

    slideToCurrent(); // call callbacks

    onChange(indices.current);
    onNextCompleted();
  }, [currentItem, loop, onChange, perPage, slideToCurrent, updateIndices]); // triggers transition between items after a drag is detected

  var updateAfterDrag = function updateAfterDrag() {
    var movement = drag.endX - drag.startX;

    if (movement > 0 && Math.abs(movement) > threshold) {
      prev();
    } else if (movement < 0 && Math.abs(movement) > threshold) {
      next();
    }

    slideToCurrent();
    setDragged(true);
  }; // sets CSS properties for transitions


  var setStyle = function setStyle(target, styles) {
    Object.keys(styles).forEach(function (attribute) {
      target.style[attribute] = styles[attribute];
    });
  }; // reset transition params for slides with eases


  var resetTransitionStyles = function resetTransitionStyles() {
    setStyle(sliderRef.current, {
      cursor: "grab",
      transition: "all " + duration + "ms " + easing
    });
  }; // translate the items according to the mouse/touch movements


  var setDraggingStyles = function setDraggingStyles() {
    setStyle(sliderRef.current, {
      transition: "all 0ms " + easing,
      transform: "translate3d(" + (currentItem * (galleryWidth / perPage) + (drag.startX - drag.endX)) * -1 + "px, 0, 0)"
    });
  };

  var onTouchStart = function onTouchStart(e) {
    e.stopPropagation();
    isDown = true;
    drag.startX = e.touches[0].pageX;
    drag.startY = e.touches[0].pageY;
  };

  var onTouchEnd = function onTouchEnd(e) {
    e.stopPropagation();
    isDown = false;
    setStyle(sliderRef.current, {
      transition: "all " + duration + "ms " + easing
    });

    if (drag.endX) {
      updateAfterDrag();
    }

    clearDrag();
  };

  var onTouchMove = function onTouchMove(e) {
    e.stopPropagation();

    if (drag.letGo === null) {
      drag.letGo = Math.abs(drag.startY - e.touches[0].pageY) < Math.abs(drag.startX - e.touches[0].pageX);
    }

    if (isDown && drag.letGo) {
      drag.endX = e.touches[0].pageX;
      setDraggingStyles();
    }
  };

  var onMouseDown = function onMouseDown(e) {
    e.preventDefault();
    e.stopPropagation();
    isDown = true;
    drag.startX = e.pageX; // set the cursor to the grabbing during the drag

    setStyle(sliderRef.current, {
      cursor: "grabbing"
    });
  };

  var onMouseUp = function onMouseUp(e) {
    e.stopPropagation();
    isDown = false;
    resetTransitionStyles();

    if (drag.endX) {
      updateAfterDrag();
    }

    clearDrag();
  };

  var onMouseMove = function onMouseMove(e) {
    e.preventDefault();

    if (isDown) {
      drag.endX = e.pageX;
      setDraggingStyles();
    }
  };

  var onMouseLeave = function onMouseLeave(e) {
    if (isDown) {
      isDown = false;
      drag.endX = e.pageX;
      resetTransitionStyles();
      updateAfterDrag();
      clearDrag();
    }
  }; // go to a specified item in the gallery


  var goTo = function goTo(index) {
    updateIndices(Math.min(Math.max(index, 0), innerElements.current.length - 1));
    slideToCurrent();
    onChange(indices.current);
  }; // callback for a window resize event; resizes gallery


  var resize = useCallback(function () {
    setWidth(galleryRef.current.getBoundingClientRect().width);
    setStyle(sliderRef.current, {
      width: galleryWidth / perPage * innerElements.current.length + "px"
    });
  }, [galleryWidth, perPage]);
  var debouncedResize = debounce(function () {
    resize();
    slideToCurrent();
  }, resizeDebounce); // autoscrolling side effects

  useEffect(function () {
    var interval;

    if (autoScroll) {
      interval = setInterval(function () {
        next();
        slideToCurrent();
      }, autoScrollInterval);
    }

    return function () {
      clearInterval(interval);
    };
  }, [autoScroll, autoScrollInterval, next, slideToCurrent]); // setup width and resize handlers

  useEffect(function () {
    if (dragged) {
      slideToCurrent(); // just slide to the next item if it's been initialized
    } else if (sliderRef.current) {
      // save the children in a ref
      innerElements.current = [].slice.call(sliderRef.current.children); // set width of the gallery

      setWidth(galleryRef.current.getBoundingClientRect().width);

      if (galleryWidth) {
        setStyle(sliderRef.current, {
          cursor: "grab",
          width: galleryWidth / perPage * innerElements.current.length + "px",
          transition: "all " + duration + "ms " + easing
        });
        innerElements.current.forEach(function (element) {
          setStyle(element, {
            width: 100 / innerElements.current.length + "%"
          });
        });
        window.addEventListener("resize", debouncedResize);
        slideToCurrent();
        onInit();
      }
    }

    return function () {
      window.removeEventListener("resize", debouncedResize);
    };
  }, [currentItem, debouncedResize, dragged, duration, easing, galleryWidth, isDown, onChange, onInit, perPage, resize, resizeDebounce, slideToCurrent, startIndex, updateIndices]);
  var eventHandlers = draggable ? {
    onTouchStart: onTouchStart,
    onTouchEnd: onTouchEnd,
    onTouchMove: onTouchMove,
    onMouseDown: onMouseDown,
    onMouseUp: onMouseUp,
    onMouseMove: onMouseMove,
    onMouseLeave: onMouseLeave
  } : {};
  return createElement(GalleryContainer, __assign$b({
    className: className,
    ref: galleryRef
  }, eventHandlers), createElement(GallerySlider, {
    className: "gallery__slider",
    ref: sliderRef
  }, children), showIndicators && innerElements.current && getIndicators(useThemedIndicators, innerElements.current.length, currentItem, goTo));
};

var index$2 = withTheme(function (_a) {
  var theme = _a.theme,
      rest = __rest$b(_a, ["theme"]);

  return createElement(theme.gallery, __assign$b({
    useThemedIndicators: true
  }, rest));
});
var templateObject_1$c, templateObject_2$3;

var __makeTemplateObject$d = undefined && undefined.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign$c = undefined && undefined.__assign || function () {
  __assign$c = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign$c.apply(this, arguments);
};

var __rest$c = undefined && undefined.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

var RawLink = styled.a(templateObject_1$d || (templateObject_1$d = __makeTemplateObject$d(["\n  color: inherit;\n  text-decoration: none;\n"], ["\n  color: inherit;\n  text-decoration: none;\n"])));

var UnstyledLink = function UnstyledLink(_a) {
  var children = _a.children,
      _b = _a.newTab,
      newTab = _b === void 0 ? false : _b,
      _c = _a.download,
      download = _c === void 0 ? false : _c,
      url = _a.href,
      className = _a.className;
  var target = newTab ? "_blank" : undefined;
  var rel = newTab ? "noopener noreferrer" : "";
  return createElement(RawLink, {
    href: url,
    target: target,
    rel: rel,
    download: download,
    className: className
  }, children);
};

var index$3 = withTheme(function (_a) {
  var theme = _a.theme,
      rest = __rest$c(_a, ["theme"]);

  return createElement(theme.link, __assign$c({}, rest));
});
var templateObject_1$d;

var __makeTemplateObject$e = undefined && undefined.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign$d = undefined && undefined.__assign || function () {
  __assign$d = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign$d.apply(this, arguments);
};

var __rest$d = undefined && undefined.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

var Wrapper = styled.div(templateObject_1$e || (templateObject_1$e = __makeTemplateObject$e(["\n  /* stylelint-disable no-empty-block */\n"], ["\n  /* stylelint-disable no-empty-block */\n"])));

var UnstyledLoader = function UnstyledLoader(_a) {
  var className = _a.className,
      loading = _a.loading,
      render = _a.render;

  var getRender = function getRender() {
    if (typeof render === "function") {
      return render();
    } else if (typeof render === "object") {
      return render;
    } else {
      /* eslint-disable no-console */
      console.error("render prop must be a single JSX element or a function callback");
    }
  };

  return createElement(Wrapper, {
    className: className
  }, loading && getRender());
};

var index$4 = withTheme(function (_a) {
  var theme = _a.theme,
      rest = __rest$d(_a, ["theme"]);

  return createElement(theme.loader, __assign$d({}, rest));
});
var templateObject_1$e;

var __makeTemplateObject$f = undefined && undefined.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};
/**
 * Converts device breakpoints to tagged template literals that can be used as media queries
 * @param breakpoints - A dictionary of device breakpoints, representing a value `w` (measured in `px`). Any width `x` that falls in the range `0 <= x <= w` will have the css defined in the media query applied.
 */


var createMediaQueryTemplate = function createMediaQueryTemplate(breakpoints) {
  return Object.keys(breakpoints).reduce(function (acc, label) {
    acc[label] = function (literals) {
      var args = [];

      for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
      }

      return css(templateObject_1$f || (templateObject_1$f = __makeTemplateObject$f(["\n      @media (max-width: ", "px) {\n        ", "\n      }\n    "], ["\n      @media (max-width: ", "px) {\n        ", "\n      }\n    "])), breakpoints[label], css.apply(void 0, [literals].concat(args)));
    };

    return acc;
  }, {});
};

var templateObject_1$f;

var __makeTemplateObject$g = undefined && undefined.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign$e = undefined && undefined.__assign || function () {
  __assign$e = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign$e.apply(this, arguments);
};

var __rest$e = undefined && undefined.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

var RawTextAreaInput = styled.textarea(templateObject_1$g || (templateObject_1$g = __makeTemplateObject$g(["\n  /* stylelint-disable no-empty-block */\n"], ["\n  /* stylelint-disable no-empty-block */\n"])));
/**
 * A multi-line `TextAreaInput` component, unstyled.
 */

var UnstyledTextAreaInput = function UnstyledTextAreaInput(_a) {
  var className = _a.className,
      defaultValue = _a.defaultValue,
      onChange = _a.onChange,
      placeholder = _a.placeholder,
      value = _a.value,
      label = _a.label,
      _b = _a.readOnly,
      readOnly = _b === void 0 ? false : _b,
      disabled = _a.disabled,
      maxLength = _a.maxLength,
      tabIndex = _a.tabIndex,
      onFocus = _a.onFocus,
      onBlur = _a.onBlur,
      onKeyDown = _a.onKeyDown,
      onKeyPress = _a.onKeyPress,
      onKeyUp = _a.onKeyUp;
  /**
   * Memoized onChange callback for the html text input element. Returns the text value rather
   * than the change event.
   */

  var internalOnChange = useCallback(function (event) {
    onChange(event.target.value);
  }, [onChange]);
  var keyEvents = useKeyEvents(onKeyDown, onKeyPress, onKeyUp);
  return createElement(RawTextAreaInput, __assign$e({
    className: className,
    defaultValue: defaultValue,
    onChange: internalOnChange,
    placeholder: placeholder,
    value: value,
    readOnly: readOnly,
    disabled: disabled,
    maxLength: maxLength,
    tabIndex: tabIndex,
    "aria-label": label,
    onFocus: onFocus,
    onBlur: onBlur
  }, keyEvents));
};
/**
 * A multi-line `TextAreaInput` component, withTheme.
 */


var index$5 = withTheme(function (_a) {
  var theme = _a.theme,
      rest = __rest$e(_a, ["theme"]);

  return createElement(theme.textAreaInput, __assign$e({}, rest));
});
var templateObject_1$g;
/**
 * Clamps value to between min and max
 */

var clamp = function clamp(value, min, max) {
  return Math.min(Math.max(value, min), max);
};
/**
 * Given a set of bounds, converts a value to a percentage
 * @param value - The value between min and max to be converted to a percentage
 * @param min - The minimum possible value
 * @param max - The maximum possible value
 */


var percentify = function percentify(value, min, max) {
  return (value - min) / (max - min) * 100;
};

var __makeTemplateObject$h = undefined && undefined.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var RawProgressContainer = styled.div(templateObject_1$h || (templateObject_1$h = __makeTemplateObject$h(["\n  width: 100%;\n  overflow: hidden;\n"], ["\n  width: 100%;\n  overflow: hidden;\n"])));

var UnstyledProgressContainer = function UnstyledProgressContainer(_a) {
  var children = _a.children,
      className = _a.className;
  return createElement(RawProgressContainer, {
    className: className
  }, children);
};

var RawProgress = styled.div(templateObject_2$4 || (templateObject_2$4 = __makeTemplateObject$h(["\n  height: 100%;\n"], ["\n  height: 100%;\n"])));

var UnstyledProgress = function UnstyledProgress(_a) {
  var percentage = _a.percentage,
      className = _a.className;
  return createElement(RawProgress, {
    className: className,
    style: {
      width: percentage + "%"
    }
  });
};

var Progress = styled.progress(templateObject_3 || (templateObject_3 = __makeTemplateObject$h(["\n  display: none;\n"], ["\n  display: none;\n"])));
var index$6 = withTheme(function (_a) {
  var theme = _a.theme,
      _b = _a.min,
      min = _b === void 0 ? 0 : _b,
      _c = _a.max,
      max = _c === void 0 ? 100 : _c,
      progress = _a.progress,
      className = _a.className;
  var clampedProgress = clamp(progress, min, max);
  var percentage = percentify(clampedProgress, min, max);
  return createElement(theme.progressContainer, {
    className: className
  }, createElement(Progress, {
    max: "100",
    value: percentage
  }), createElement(theme.progress, {
    percentage: percentage
  }));
});
var templateObject_1$h, templateObject_2$4, templateObject_3;

var __makeTemplateObject$i = undefined && undefined.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign$f = undefined && undefined.__assign || function () {
  __assign$f = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign$f.apply(this, arguments);
};
/**
 * Converts a component definition to a styled component
 * @param componentDefinition - The component definition to convert
 * @param componentDefinition.component - The component to apply the variants to
 * @param componentDefinition.sharedStyles - Shared styles across all instances of the component
 * @param componentDefinition.variants - The variant styles to apply on the component
 */


var componentFromDefinition = function componentFromDefinition(_a) {
  var component = _a.component,
      sharedStyles = _a.sharedStyles,
      variants = _a.variants;
  return styled(component)(templateObject_1$i || (templateObject_1$i = __makeTemplateObject$i(["\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n"])), function (_a) {
    var removeSharedStyles = _a.removeSharedStyles;
    return removeSharedStyles ? "" : sharedStyles;
  }, function (_a) {
    var variant = _a.variant;
    return typeof variant === "string" && variants && variants[variant];
  });
};
/**
 * Converts a theme definition to a theme
 * @param themeDefinition - The theme definition to convert to a theme
 */


var themeFromDefinition = function themeFromDefinition(themeDefinition) {
  // Creates a media query template literal function for each breakpoint
  var mediaQueries = themeDefinition.deviceBreakpoints && createMediaQueryTemplate(themeDefinition.deviceBreakpoints);
  return {
    mediaQueries: mediaQueries,
    globalConstants: themeDefinition.globalConstants,
    // spreading user-defined ComponentDefinitions allows them to
    // overwrite the default UnstyledComponent if they have their own defined
    button: componentFromDefinition(__assign$f({
      component: UnstyledButton
    }, themeDefinition.button || {})),
    card: componentFromDefinition(__assign$f({
      component: UnstyledCard
    }, themeDefinition.card || {})),
    carousel: componentFromDefinition(__assign$f({
      component: UnstyledCarousel
    }, themeDefinition.carousel || {})),
    dropdownContainer: componentFromDefinition(__assign$f({
      component: UnstyledDropdownContainer
    }, themeDefinition.dropdownContainer || {})),
    dropdownMultiValue: componentFromDefinition(__assign$f({
      component: UnstyledDropdownMultiValue
    }, themeDefinition.dropdownMultiValue || {})),
    dropdownMultiValueRemove: componentFromDefinition(__assign$f({
      component: UnstyledDropdownMultiValueRemove
    }, themeDefinition.dropdownMultiValueRemove || {})),
    dropdownOption: componentFromDefinition(__assign$f({
      component: UnstyledDropdownOption
    }, themeDefinition.dropdownOption || {})),
    dropdownOptionsContainer: componentFromDefinition(__assign$f({
      component: UnstyledDropdownOptionsContainer
    }, themeDefinition.dropdownOptionsContainer || {})),
    gallery: componentFromDefinition(__assign$f({
      component: UnstyledGallery
    }, themeDefinition.gallery || {})),
    indicator: componentFromDefinition(__assign$f({
      component: UnstyledIndicator
    }, themeDefinition.indicator || {})),
    link: componentFromDefinition(__assign$f({
      component: UnstyledLink
    }, themeDefinition.link || {})),
    loader: componentFromDefinition(__assign$f({
      component: UnstyledLoader
    }, themeDefinition.loader || {})),
    progress: componentFromDefinition(__assign$f({
      component: UnstyledProgress
    }, themeDefinition.progress || {})),
    progressContainer: componentFromDefinition(__assign$f({
      component: UnstyledProgressContainer
    }, themeDefinition.progressContainer || {})),
    text: componentFromDefinition(__assign$f({
      component: UnstyledText
    }, themeDefinition.text || {})),
    textAreaInput: componentFromDefinition(__assign$f({
      component: UnstyledTextAreaInput
    }, themeDefinition.textAreaInput || {})),
    textInput: componentFromDefinition(__assign$f({
      component: UnstyledTextInput
    }, themeDefinition.textInput || {}))
  };
};

var North = function North(_a) {
  var themeDefinition = _a.themeDefinition,
      children = _a.children;
  var theme = themeFromDefinition(themeDefinition);
  return createElement(ThemeProvider, {
    theme: theme
  }, createElement(Fragment, null, themeDefinition.globalStyles && createElement(themeDefinition.globalStyles, null), children));
};

var templateObject_1$i;
/* Components (in alphabetical order) */

export { Button, index as Card, index$1 as Carousel, Dropdown$1 as Dropdown, DropdownContainer, DropdownOption, DropdownOptionsContainer, index$2 as Gallery, GallerySlider, Indicator, index$3 as Link, index$4 as Loader, MultiDropdown, North, index$6 as ProgressBar, Text, index$5 as TextAreaInput, TextInput, UnstyledButton, UnstyledCard, UnstyledCarousel, UnstyledDropdownContainer, UnstyledDropdownOption, UnstyledDropdownOptionsContainer, UnstyledGallery, UnstyledIndicator, UnstyledLink, UnstyledLoader, UnstyledProgress, UnstyledProgressContainer, UnstyledText, UnstyledTextAreaInput, UnstyledTextInput, createMediaQueryTemplate, getIndicators, themeFromDefinition, useKeyEvents, useOnClickOutside };